// Created by base in react-phone-input-2
// for create new country list
// 1) copy data from https://github.com/bl00mber/react-phone-input-2/blob/master/src/rawCountries.js [rawCountries]
// 2) process data from script
//
//  rawCountries.filter((el: any) => el[1].includes('europe'))
//    .map((el: any) => {
//      return {
//        label: el[2],
//        code: el[3],
//        mask: el?.[4]?.replaceAll('.', '9'),
//        name: el?.[0],
//        placeholder: el?.[4]?.replaceAll('.', 'x'),
//      };
//    });
// 3) update countriesList

export interface ICountry {
  label: string;
  code: string;
  name: string;
  mask?: string | { value: string; rule?: RegExp }[];
  placeholder?: string;
}

export const countriesList: ICountry[] = [
  {
    label: 'al',
    code: '355',
    name: 'Albania',
  },
  {
    label: 'ad',
    code: '376',
    name: 'Andorra',
  },
  {
    label: 'at',
    code: '43',
    name: 'Austria',
  },
  {
    label: 'by',
    code: '375',
    mask: '(99) 999 99 99',
    name: 'Belarus',
    placeholder: '(xx) xxx xx xx',
  },
  {
    label: 'be',
    code: '32',
    mask: [
      { value: '999 99 99 99', rule: /^(?!0)\d*/ },
      { value: '9999 99 99 99', rule: /^0\d*/ },
    ],
    name: 'Belgium',
    placeholder: 'xxx xx xx xx',
  },
  {
    label: 'ba',
    code: '387',
    name: 'Bosnia and Herzegovina',
  },
  {
    label: 'bg',
    code: '359',
    name: 'Bulgaria',
  },
  {
    label: 'hr',
    code: '385',
    name: 'Croatia',
  },
  {
    label: 'cy',
    code: '357',
    mask: '99 999999',
    name: 'Cyprus',
    placeholder: 'xx xxxxxx',
  },
  {
    label: 'cz',
    code: '420',
    mask: '999 999 999',
    name: 'Czech Republic',
    placeholder: 'xxx xxx xxx',
  },
  {
    label: 'dk',
    code: '45',
    mask: '99 99 99 99',
    name: 'Denmark',
    placeholder: 'xx xx xx xx',
  },
  {
    label: 'ee',
    code: '372',
    mask: '9999 999999',
    name: 'Estonia',
    placeholder: 'xxxx xxxxxx',
  },
  {
    label: 'fi',
    code: '358',
    mask: '99 999 99 99',
    name: 'Finland',
    placeholder: 'xx xxx xx xx',
  },
  {
    label: 'fr',
    code: '33',
    mask: '9 99 99 99 99',
    name: 'France',
    placeholder: 'x xx xx xx xx',
  },
  {
    label: 'de',
    code: '49',
    mask: '9999 99999999',
    name: 'Germany',
    placeholder: 'xxxx xxxxxxxx',
  },
  {
    label: 'gr',
    code: '30',
    name: 'Greece',
  },
  {
    label: 'hu',
    code: '36',
    name: 'Hungary',
  },
  {
    label: 'is',
    code: '354',
    mask: '999 9999',
    name: 'Iceland',
    placeholder: 'xxx xxxx',
  },
  {
    label: 'ie',
    code: '353',
    mask: '99 9999999',
    name: 'Ireland',
    placeholder: 'xx xxxxxxx',
  },
  {
    label: 'it',
    code: '39',
    mask: '999 9999999',
    name: 'Italy',
    placeholder: 'xxx xxxxxxx',
  },
  {
    label: 'xk',
    code: '383',
    name: 'Kosovo',
  },
  {
    label: 'lv',
    code: '371',
    mask: '99 999 999',
    name: 'Latvia',
    placeholder: 'xx xxx xxx',
  },
  {
    label: 'li',
    code: '423',
    name: 'Liechtenstein',
  },
  {
    label: 'lt',
    code: '370',
    name: 'Lithuania',
  },
  {
    label: 'lu',
    code: '352',
    name: 'Luxembourg',
  },
  {
    label: 'mk',
    code: '389',
    name: 'Macedonia',
  },
  {
    label: 'mt',
    code: '356',
    name: 'Malta',
  },
  {
    label: 'md',
    code: '373',
    mask: '(99) 99-99-99',
    name: 'Moldova',
    placeholder: '(xx) xx-xx-xx',
  },
  {
    label: 'mc',
    code: '377',
    name: 'Monaco',
  },
  {
    label: 'me',
    code: '382',
    name: 'Montenegro',
  },
  {
    label: 'nl',
    code: '31',
    mask: '99 99999999',
    name: 'Netherlands',
    placeholder: 'xx xxxxxxxx',
  },
  {
    label: 'no',
    code: '47',
    mask: '999 99 999',
    name: 'Norway',
    placeholder: 'xxx xx xxx',
  },
  {
    label: 'pl',
    code: '48',
    mask: '999-999-999',
    name: 'Poland',
    placeholder: 'xxx-xxx-xxx',
  },
  {
    label: 'pt',
    code: '351',
    name: 'Portugal',
  },
  {
    label: 'ro',
    code: '40',
    name: 'Romania',
  },
  {
    label: 'ru',
    code: '7',
    mask: '(999) 999-99-99',
    name: 'Russia',
    placeholder: '(xxx) xxx-xx-xx',
  },
  {
    label: 'sm',
    code: '378',
    name: 'San Marino',
  },
  {
    label: 'rs',
    code: '381',
    name: 'Serbia',
  },
  {
    label: 'sk',
    code: '421',
    name: 'Slovakia',
  },
  {
    label: 'si',
    code: '386',
    name: 'Slovenia',
  },
  {
    label: 'es',
    code: '34',
    mask: '999 999 999',
    name: 'Spain',
    placeholder: 'xxx xxx xxx',
  },
  {
    label: 'se',
    code: '46',
    mask: '(999) 999-999',
    name: 'Sweden',
    placeholder: '(xxx) xxx-xxx',
  },
  {
    label: 'ch',
    code: '41',
    mask: '99 999 99 99',
    name: 'Switzerland',
    placeholder: 'xx xxx xx xx',
  },
  {
    label: 'tr',
    code: '90',
    mask: '999 999 99 99',
    name: 'Turkey',
    placeholder: 'xxx xxx xx xx',
  },
  {
    label: 'ua',
    code: '380',
    mask: '(99) 999 99 99',
    name: 'Ukraine',
    placeholder: '(xx) xxx xx xx',
  },
  {
    label: 'gb',
    code: '44',
    mask: '9999 999999',
    name: 'United Kingdom',
    placeholder: 'xxxx xxxxxx',
  },
  {
    label: 'va',
    code: '39',
    mask: '99 9999 9999',
    name: 'Vatican City',
    placeholder: 'xx xxxx xxxx',
  },
];
